import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../services/API/auth/auth.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  rol = "";

  constructor(public authService: AuthService) { }

  ngOnInit(): void {
    this.rol = (localStorage.getItem('appAuthRol') || '');
  }

  userRolCheck(permission: string){
    return this.authService.userRolCheck(permission);
  }

}
